import { useRouter } from "@tanstack/react-router";
import type { MouseEvent } from "react";

// Pinta HTML ya saneado en el servidor (specs/138, D3/D4). Los clics en enlaces internos se resuelven
// con el router (navegación sin recarga, como los <Link> que reemplazan); los externos no se tocan.

interface Props {
  html: string;
  /** `span` para texto en línea (listas, tarjetas, FAQ); `div` para bloques con párrafos. */
  as?: "div" | "span";
  className?: string;
}

function esEnlaceInterno(a: HTMLAnchorElement): string | null {
  const href = a.getAttribute("href");
  if (!href || !href.startsWith("/") || href.startsWith("//")) return null;
  if (a.target && a.target !== "_self") return null;
  return href;
}

export function ContenidoMarkdown({ html, as = "div", className }: Props) {
  const router = useRouter();
  const alHacerClic = (e: MouseEvent<HTMLElement>) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }
    const a = (e.target as HTMLElement).closest("a");
    if (!a) return;
    const href = esEnlaceInterno(a as HTMLAnchorElement);
    if (!href) return;
    e.preventDefault();
    void router.navigate({ href });
  };
  const Tag = as;
  return (
    <Tag className={className} onClick={alHacerClic} dangerouslySetInnerHTML={{ __html: html }} />
  );
}

/** Texto corto con HTML saneado opcional (listas, tarjetas, respuestas de FAQ). */
export function TextoRico({
  t,
  className,
}: {
  t: { html: string | null; texto: string };
  className?: string;
}) {
  return t.html ? (
    <ContenidoMarkdown as="span" html={t.html} className={className} />
  ) : (
    <>{t.texto}</>
  );
}

/** Enlaces dentro de contenido editado: mismo trato que los <Link> que tenían antes. */
export const ESTILO_ENLACES =
  "[&_a]:font-semibold [&_a]:text-primary [&_a:hover]:underline [&_a]:underline-offset-4";
